import React, { useCallback } from 'react';
import cn from 'classnames';
import { IBaseSection, IContent } from 'src/interface';
import ContentService from 'src/services/ContentService';
import { ALIGN_TYPE, LIST_TYPE } from 'src/components';
import { InfiniteList } from 'src/modules/shared/components/InfiniteList';
import { ContentList } from '../list';

interface IProps extends IBaseSection<IContent> {
    className?: string;
    alignList?: ALIGN_TYPE;
    typeList?: LIST_TYPE;
    alignItem?: ALIGN_TYPE;
    hasLayoutPhoto?: boolean;
    displayTimeIn?: number;
    ComponentList?: React.FunctionComponent<any>;
    ComponentListProps?: any;
    ContentItemProps?: any;
    isMobile?: boolean;
    showButtonLoadMore?: boolean;
}

export default React.memo(function ContentMoreSection(props: IProps) {
    const {
        items = [],
        isMobile = true,
        className = '',
        typeList,
        alignList,
        alignItem,
        hasLayoutPhoto = true,
        displayTimeIn,
        ComponentList = ContentList,
        tracking,
        showButtonLoadMore = true,
        options = {},
        ContentItemProps,
    } = props;
    const fetchFn = useCallback(
        (page: number, _filter: {}, index: number): Promise<any> => {
            let params = Object.assign({}, options?.more?.params);
            params.page = page || 1;
            params.lastIndex = index || 1;
            return ContentService.getList(options?.more?.url, params);
        },
        [options]
    );

    let ListProps = {
        ComponentList,
        ComponentListProps: {
            align: alignList,
            alignItem: alignItem,
            type: typeList,
            hasLayoutPhoto,
            displayTimeIn,
            isMobile,
            tracking,
            ContentItemProps,
        },
        fetchFn: fetchFn,
        items: items,
        showButtonLoadMore: showButtonLoadMore,
        currentPage: options?.more?.params?.page,
    };

    return <InfiniteList {...ListProps} className={cn(className)} />;
});
